import { computed } from "vue";
import { sortBy } from "lodash";
import { useUserRolesStore } from "@/stores/user-roles";
import { storeToRefs } from "pinia";
import { upsertRole, deleteRole } from "@/queries/user-roles";

export function useUserRoles() {
  const userRolesStore = useUserRolesStore();
  const { userRoles, isLoading } = storeToRefs(userRolesStore);

  return {
    userRoles,
    saveRole: upsertRole,
    deleteRole,
    isLoading,
  };
}
